module.exports = __webpack_public_path__ + "img/discord_@2x.203210a3.png";